<template>
    <div>
        <b-button class="w-100 mb-1"
                  variant="outline-secondary"
                  v-show="servicestatus.notifications_enabled"
                  @click="disableNotifications">
            <i class="fa-solid fa-envelope"></i>
            {{ $t('action-items.notifications-disable') }}
        </b-button>
        <b-button class="w-100 mb-1"
                  variant="outline-secondary"
                  v-show="!servicestatus.notifications_enabled"
                  @click="enableNotifications">
            <i class="fa-solid fa-envelope"></i>
            {{ $t('action-items.notifications-enable') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: "Notifications",
    props: [
        'uuids',
        'servicestatus'
    ],
    methods: {
        enableNotifications(){
            let externalCommands = [];
            externalCommands.push({
                command: 'submitEnableServiceNotifications',
                hostUuid: this.uuids.hostuuid,
                serviceUuid: this.uuids.serviceuuid,

            });
            this.$emit('command', externalCommands, 'submit');
        },
        disableNotifications(){
            let externalCommands = [];
            externalCommands.push({
                command: 'submitDisableServiceNotifications',
                serviceUuid: this.uuids.serviceuuid,
                hostUuid: this.uuids.hostuuid
            });
            this.$emit('command', externalCommands, 'submit');
        },
    }
}
</script>

<style scoped>

</style>
